import type { IconType } from "react-icons";
import { Box, Card, Flex, Icon, Text } from "@chakra-ui/react";

type StatCardProps = {
  label: string;
  value: string;
  detail: string;
  icon: IconType;
  tone?: "primary" | "secondary" | "accent" | "info";
};

const toneColors: Record<NonNullable<StatCardProps["tone"]>, string> = {
  primary: "blue.500",
  secondary: "teal.500",
  accent: "yellow.500",
  info: "cyan.500",
};

export function StatCard({
  label,
  value,
  detail,
  icon: IconComponent,
  tone = "primary",
}: StatCardProps) {
  return (
    <Card.Root borderWidth="1px" borderColor="border">
      <Card.Body gap={5} p={5}>
        <Flex align="flex-start" justify="space-between" gap={4}>
          <Box>
            <Text fontSize="xs" fontWeight="semibold" textTransform="uppercase" letterSpacing="0.24em" color="fg.muted">
              {label}
            </Text>
            <Text mt={3} fontSize="3xl" fontWeight="semibold">{value}</Text>
          </Box>
          <Icon as={IconComponent} boxSize={7} color={toneColors[tone]} />
        </Flex>
        <Text fontSize="sm" color="fg.muted">{detail}</Text>
      </Card.Body>
    </Card.Root>
  );
}
